import { MandateColumns, AssetTableViewMode } from "../../../../Enums/constants";
import ibsStore from "../../../Stores/IbsSurveyStore"
import { log } from "util";
import { isUK, isLGPS } from "../../../../ibsHelper";
import { checkIfAnalyst } from "../../../../Services/IBS/IbsService";
import { checkAllChildrenEmptyForQ } from "../../../../Helpers/TableCalculationHelper";
import { getSurveyResponseValue } from "../../../../Helpers/General/SurveyResponsesHelper";

//manage hidden columns here
export function getHiddenMandateColumns (props) {
    log(`getHiddenColumns`, 1);
    let hideCols = []
    if (props.hiddenColumns && props.hiddenColumns.length > 0) hideCols = hideCols.concat(props.hiddenColumns);
    let currentAvgYearEndSelection = getSurveyResponseValue("IsAvgAssetsGiv")
    hideCols.push(MandateColumns.ASSET_CLASS_CATEGORY);
    hideCols.push(MandateColumns.NAV_END);
    hideCols.push(MandateColumns.FEE_END);
    if (!isUK()) {
        hideCols.push(MandateColumns.INTERNAL_OTHER_COSTS)
    }


    //is an lgps survey, what to do in asset table case
    if (isLGPS()) {
        hideCols.push(MandateColumns.NAV_END)
        hideCols.push(MandateColumns.FEE_END)
    }

    if (ibsStore.currentSurvey) {
        var hasCostValues = false;
        if (ibsStore.allTableResponses["combinedAssets"]) {
            hasCostValues = ibsStore.allTableResponses["combinedAssets"]
                .filter(item => {
                    const costs = item["InternalMonitoringCost"];
                    return (costs && typeof costs !== 'undefined');
                }).length > 0;
        }
        if (ibsStore.allTableResponses["combinedAssets"]) {
            var hasFOFvaluesA = false;
            hasFOFvaluesA = ibsStore.allTableResponses["combinedAssets"]
                .filter(item => {
                    const styleName = item["StyleName"];
                    return (styleName && typeof styleName == 'string' && styleName.startsWith("Fund of Funds"));
                }).length > 0;
        }
        if (ibsStore.mandateData) {
            var hasFOFvaluesM = false;
            hasFOFvaluesM = ibsStore.mandateData
                .filter(item => {
                    const styleName = item["styleName"];
                    return (styleName && typeof styleName == 'string' && styleName.startsWith("Fund of Funds"));
                }).length > 0;
        }
        let isMandateLevel = ibsStore.checkMandateLevel
        if (!hasFOFvaluesA && isMandateLevel == AssetTableViewMode.ASSET_ONLY_VIEW || (!hasFOFvaluesA && !hasFOFvaluesM && isMandateLevel == AssetTableViewMode.BOTH_VIEW) || !hasFOFvaluesM && isMandateLevel == AssetTableViewMode.MANDATE_ONLY_VIEW) {
            hideCols.push(MandateColumns.UNDERLYING_PERF_FEES)
            hideCols.push(MandateColumns.UNDERLYING_BASE_FEES)
        } else {
            let index = hideCols.indexOf(MandateColumns.UNDERLYING_PERF_FEES);
            let index2 = hideCols.indexOf(MandateColumns.UNDERLYING_BASE_FEES);
            if (index > -1) hideCols.splice(index, 1);
            if (index2 > -1) hideCols.splice(index2, 1)
        }
        if (ibsStore.isEnhanced) {
            if (hasCostValues) {
                //Show but grey it out
            }
            else {
                hideCols.push(MandateColumns.INTERNAL_OTHER_COSTS)
            }
        } else {
            hideCols.push(MandateColumns.INTERNAL_TEAMS)
            let hasInternalStyles = false
            if (ibsStore.checkMandateLevel != AssetTableViewMode.MANDATE_ONLY_VIEW) {
                hasInternalStyles = ibsStore.allTableResponses["combinedAssets"] ? ibsStore.allTableResponses["combinedAssets"]
                    .filter(item => {
                        const styleName = item["StyleName"];
                        return (styleName && typeof styleName == 'string' && styleName.startsWith("Int"));
                    }).length > 0 : false;
            } else {
                hasInternalStyles = ibsStore.mandateData ? ibsStore.mandateData
                    .filter(item => {
                        const styleName = item["styleName"];
                        return (styleName && typeof styleName == 'string' && styleName.startsWith("Int"));
                    }).length > 0 : false;
            }

            let hasInternalCosts = getSurveyResponseValue("HasInternalCosts")
            if (hasInternalCosts === true || hasInternalCosts != 0
                || hasCostValues
                || hasInternalStyles) {
                //show
                const index = hideCols.indexOf(MandateColumns.INTERNAL_OTHER_COSTS);
                if (index > -1) {
                    hideCols.splice(index, 1);
                }
            }
            else {
                hideCols.push(MandateColumns.INTERNAL_OTHER_COSTS)
            }
        }
        if (ibsStore.allTableResponses["CustomGroupings"] && (![4, 5, 6].includes(ibsStore.currentSurvey.EnhancedInternalID))) {
            hideCols.push(MandateColumns.CUSTOM_GROUPING)
        }

        hideCols.push(MandateColumns.FUND_NAME)
        hideCols.push(MandateColumns.STYLE_NAME)
        if (isMandateLevel == AssetTableViewMode.MANDATE_ONLY_VIEW) {
            hideCols.push(MandateColumns.ASSET_CLASS_NAME)
        } else if (isMandateLevel == AssetTableViewMode.BOTH_VIEW) {
            hideCols.push(MandateColumns.MANAGER_NAME)
        } else if (isMandateLevel == AssetTableViewMode.ASSET_ONLY_VIEW) {
            hideCols.push(MandateColumns.MANAGER_NAME)
            hideCols.push(MandateColumns.MANDATE_STATUS)
        }
        if (!checkIfAnalyst()) {
            hideCols.push(MandateColumns.REPORT_INCLUSION)

        }
    }

    let rowIdCol = props.headers.findIndex((element) => (element === "RowID"));
    if (rowIdCol > -1) hideCols.push(rowIdCol) //always hide row ID, would be better if we could save the rowID in ID tag on td

    return (hideCols)

}
